export default function setPickupStatus(data) {
    return data === "ready-for-pickup";
}